import {Component, ViewChild} from '@angular/core';
import {SuperClass} from '../../../../superclass/SuperClass';
import {WsService} from '../../../../services/websocket/WsService';
import {RouterConst} from '../../../../globals/RoutersConst';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {DashboardDataService} from '../../../../services/dashboard-data.service';
import {ClientsService} from '../../../../services/clients/clients.service';
import {HttpClient} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import {Globals} from '../../../../globals/Globals';
import {Observable} from "rxjs";

@Component({
  selector: 'app-opt-in',
  templateUrl: './opt-in.component.html',
  styleUrls: ['./opt-in.component.css']
})
export class OptInComponent extends SuperClass {

  offset: number = 0;
  size: number = 25;
  totalRecords: number = 0;

  users: Observable<String>;
  lazy: boolean = true;
  loading: string = 'none';

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Dashboards' },
      { label: 'Reporting' },
      {
        label: 'OptIn Users',
        routerLink: [{ outlets: { sub: [RouterConst.OPT_IN_USERS] } }],
      },
    ]);
  }

  selectRow(e) {}

  getDate(date) {
    return new Date(date);
  }

  setPage(event){
    this.offset = event.first / event.rows;
    this.reloadData();
  }

  reloadData(): void {
    this.loading = 'block';
    this.http_getOptInUsers(this.offset, this.size,(data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          this.totalRecords = data.payload.totalElements;
          let users = data.payload.content;

          for (let i = 0; i < users.length; i++) {
            users[i].createdOn = users[i].createdOn !== null ? new Date(users[i].createdOn) : '';
            users[i].lastVisit = users[i].lastVisit !== null ? new Date(users[i].lastVisit) : '';
          }

          this.users = users;
          this.loading = 'none';
      }
    });
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/dashboards/reporting/opt-in/opt-in.component.ts